Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "MembershipButton1067192240",
  {"root":"MembershipButton1067192240--root"},
  "",
  1,
  "MembershipButton1067192240"
);

